import { Injectable } from '@angular/core';
import { RootScopeService } from './root-scope.service';
import * as Constants from './../models/Constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { BehaviorSubject, delay, Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class TbaBusinessLogicService {

  constructor(
    private  rootScope: RootScopeService
) { 
    
  }

  closeCustomerTbaScreens(tab){
    //Close TBA screens related to customer start
    let tbaClosePayload = this.rootScope.tbaPayloadMap?.get(tab?.customerSessionId);
    /**
     * find data is avaible or not
     */
    if(tbaClosePayload){
      tbaClosePayload.action = Constants.TBA_CLOSE_PERSON;
      this.callTbaApi(tbaClosePayload);
      this.rootScope.tbaPayloadMap.delete(tab?.customerSessionId);
    }
    // Close TBA screens related to customer end
 }
 closeTbaLogout(){
  //Close TBA screens related to customer start
  if(!this.rootScope.TBAGUIConnected){
    return;
  }

  let tbaClosePayload = this.rootScope.tbaPayloadMap?.get(Constants.DASHBOARD_TBA_PAYLOAD);

  
  if(tbaClosePayload){
    tbaClosePayload.action = 'CLOSE_APP';
    this.callTbaApi(tbaClosePayload);
    this.rootScope.tbaPayloadMap.delete('DASHBOARD-TBA-PAYLOAD');
  }
  else{
    const sessionId = sessionStorage.getItem('tba_sessionId');
    let defaultTbaPayload = {
      focus: '',
      sessionId: sessionId,
      lifecycle:window.location.href?.includes(Constants.PROD_ENV)?Constants.LIFECYCLE:"A",
      tranId:  "",
      prsnIntnId:'',
      action: 'CLOSE_APP',
      lockedCd: '',
      fastpath: '',
      funcId: '',
      aci: '',
      tac: '',
      vrs: '',
      refId: '',
      docId: '',
      reasonCd: '',
      origId: '',
      actId: '',
      actIdType: '',
    };
    this.callTbaApi(defaultTbaPayload);
  }
}

callTbaApi(payload){
  const port = sessionStorage.getItem('tba_port');
 // const sessionId = sessionStorage.getItem('tba_sessionId');
  const url = `https://localhost:${port}/tbagui`;
 
  this.callTbaApiObs(payload,url).subscribe({
    next: (res) => {
        /* istanbul ignore next */
      if (res && !res.includes('0:')) {
        this.rootScope.logEvent(Constants.ERROR, res);
        if (res) this.rootScope.enableAlerts(Constants.WARNING, Constants.TBA_CONS[200] + res);
      }
      else
        console.log("TbaWindow opened ");
    },
    error: (error) => {
      this.rootScope.logEvent(Constants.ERROR, error?.error + ": Error while hitting TBA webfront Application" );
      if (error?.error == 'Invalid Environment.') this.rootScope.enableAlerts(Constants.ERROR, Constants.TBA_CONS['Invalid Environment.']);
      else this.rootScope.enableAlerts(Constants.WARNING, Constants.TBA_NOT_REGISTERED_MSG);
    }
  })
 
}

callTbaApiObs(payload,url): Observable<any>{
  let headers = new HttpHeaders().append('Content-Type', 'application/json');
  return this.rootScope.http.post(url, payload, {
    headers: headers,
    responseType: 'text',
  });
} 


}
